import React from 'react';
import UnauthorizedComp from '../components/Auth/UnAuthorized';
import SuspenseLoadPage from '../components/Auth/SuspenceLoadPage';

const ForbiddenAccess = () => {
  return (
    <SuspenseLoadPage>
      <UnauthorizedComp
        message={`You don't have permission to access this page.`}
        backOption={false}
      />
    </SuspenseLoadPage>
  );
};

export default ForbiddenAccess;
